import React from 'react'
import { Upload, S3_DOC_NAME } from '../components'
import ProjectStore from '../Store'

const UploadBond = ({ model }) => {
  const filled = ProjectStore.formData?.data
    ?.get('projectType')
    ?.items.find((i) => i.identifier === 'uploadBond')?.filled
  const onSuccess = (url) => {
    model.setValue(url)
  }
  const onDelete = () => {
    model.setValue('')
  }
  return (
    <Upload
      docName={S3_DOC_NAME.BOND}
      onSuccess={onSuccess}
      onDelete={onDelete}
      uploaded={filled}
    />
  )
}

export default {
  identifier: 'uploadBond',
  title: 'Please upload a copy of the bond',
  component: UploadBond,
}
